module.exports = __webpack_public_path__ + "ee2973f58704f1b890f8d82841bcbc4a.MP3";